// 获取编辑器地址
export function getEditorUrl(codeType) {
    switch (codeType) {
        case 0:
            return window.location.protocol + "//" + window.location.hostname + "/work/mdEditor?t=0"
        case 1:
            return '/scratch3/index.html?t=1'
        case 2:
            return '/scratch3/index.html?t=2'
        case 3:
            return '/scratchjr/editor.html?mode=edit&filepath='
        case 4:
            return '/onlinecode/index.html?lang=turtle'
        case 5:
            return '/onlinecode/index.html?lang=python'
        case 6:
            return '/onlinecode/index.html?lang=c'
        case 7:
            return '/onlinecode/index.html?lang=cpp'
        case 8:
            return '/onlinecode/index.html?lang=java'
        case 10:
            return '/blockly/index.html?lang=zh-hans'
        default:
            return ''
    }
}

//获取代码播放器地址
export function getPlayerUrl(codeType) {
    switch (codeType) {
        case 0:
            return window.location.protocol + "//" + window.location.hostname + "/work/mdEditor?t=0"
        case 1:
            return '/scratch3/player.html?t=1'
        case 2:
            return '/scratch3/player.html?t=2'
        case 3:
            return '/scratchjr/player.html?mode=look&filepath='
        case 4:
            return '/onlinecode/player.html?lang=turtle'
        case 5:
            return '/onlinecode/player.html?lang=python'
        case 6:
            return '/onlinecode/player.html?lang=c'
        case 7:
            return '/onlinecode/player.html?lang=cpp'
        case 8:
            return '/onlinecode/player.html?lang=java'
        case 10:
            return '/blockly/index.html?lang=zh-hans'
        default:
            return ''
    }
}

//获取代码ICON
export function getCodeIcon(codeType) {
    switch (codeType) {
        case 0:
            return require("@/assets/icon/markdown.png");
        case 4:
            return require("@/assets/icon/turtle.png");
        case 5:
            return require("@/assets/icon/python.png");
        case 6:
            return require("@/assets/icon/c.png");
        case 7:
            return require("@/assets/icon/cpp.png");
        case 8:
            return require("@/assets/icon/java.png");
        case 10:
            return require("@/assets/icon/code.png");
        default:
            return require("@/assets/icon/code.png");
    }
}